<mat-icon
	[color]="iconInput.color"
	[ngClass]="iconInput.iconClass"
	*ngIf="iconInput.isMatIcon && !iconInput.isButton; else faIcon"
	>{{ iconInput.iconName }}</mat-icon
>
<ng-template #faIcon
	><mat-icon
		*ngIf="!iconInput.isMatIcon && !iconInput.isButton && !iconInput.buttonSend; else button"
		[ngClass]="iconInput.iconClass"
		[color]="iconInput.color"
		class="fa-profile-menu"
		fontSet="fa"
		[fontIcon]="iconInput.iconName"
	></mat-icon>
</ng-template>
<ng-template #button>
	<button *ngIf="!iconInput.isMatIcon && iconInput.isButton && !iconInput.buttonSend; else buttonSend" mat-stroked-button class="ald-mat-button">
		<div class="button-container flex justify-between items-center" style="display: contents">
			<mat-icon fontSet="fa" [ngClass]="iconInput.color" fontIcon="fa-check"></mat-icon>
		</div>
	</button>
</ng-template>
<ng-template #buttonSend>
	<button mat-stroked-button class="ald-mat-button">
				<p>Invia</p> <!--buttonSend-->
	</button>
</ng-template>

